const BEAMER_PRODUCT_ID = 'zeKLgqli17986'; // DO NOT CHANGE: This is your product code on Beamer

export type OnNotificationsCountChangedCallback = (newNotificationCount: number) => void;

export interface BeamerParameters {
  // eslint-disable-next-line camelcase
  product_id: string;
  right: number;
  top: number;
  button: boolean;
  bounce: boolean;
  callback?: OnNotificationsCountChangedCallback;
  // eslint-disable-next-line camelcase
  user_id?: number;
  language?: string;
}

export const config: BeamerParameters = {
  product_id: BEAMER_PRODUCT_ID,
  right: 1,
  top: 12,
  button: false,
  bounce: false,
};
